export const fontOptions = [
  { label: 'Arial', value: 'Arial,Arial,Helvetica,sans-serif' },
  { label: 'Arial Black', value: 'Arial Black,Arial Black,Gadget,sans-serif' },
  { label: 'Comic Sans MS', value: 'Comic Sans MS,Comic Sans MS,cursive' },
  { label: 'Courier New', value: 'Courier New,Courier New,Courier,monospace' },
  { label: 'Georgia', value: 'Georgia,Georgia,serif' },
  { label: 'Impact', value: 'Impact,Charcoal,sans-serif' },
  { label: 'Lucida Console', value: 'Lucida Console,Monaco,monospace' },
  { label: 'Lucida Sans Unicode', value: 'Lucida Sans Unicode,Lucida Grande,sans-serif' },
  { label: 'Palatino Linotype', value: 'Palatino Linotype,Book Antiqua,Palatino,serif' },
  { label: 'Tahoma', value: 'Tahoma,Geneva,sans-serif' },
  { label: 'Times New Roman', value: 'Times New Roman,Times,serif' },
  { label: 'Trebuchet MS', value: 'Trebuchet MS,Helvetica,sans-serif' },
  { label: 'Verdana', value: 'Verdana,Geneva,sans-serif' },
  { label: 'Gill Sans', value: 'Gill Sans,Geneva,sans-serif' },
];

export const fontSizes = [18, 20, 22, 24, 26, 28, 36, 48, 72];
